import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import CustomBrowserRouter from "../containers/custom-browser-router";
import ThemeContainer from "../containers/theme-container";
import Home from "./home";
import Login from "./login";
import ForgetPassword from "./forgetPassword";
import Register from "./register";
import DeviceTest from "./device-test";
import { RoomPage } from "./classroom";
import Loading from "../components/loading";
import Toast from "../components/toast";
import "../icons.scss";
import { PlatformContainer } from "../containers/platform-container";
import ReplayContainer from "./replay";
import { RootProvider } from "../containers/root-container";
import SmallClass from "./classroom/small-class";
import MeetClass from "./classroom/meet-class";
import OneToOne from "./classroom/one-to-one";
import BigClass from "./classroom/big-class";
import { PageNotFound } from "./404";
import ActivationCode from "./activation-code";
import EditProfile from "./editProfile";
import { remoteConfig } from "../firebase";
// import ErrorPage from './error-page/error-page';

export default function () {
  //localStorage.clear();
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const fetchConfigs = async () => {
      await remoteConfig.fetchAndActivate();
      setIsLoaded(true);
    };

    fetchConfigs();
  }, [isLoaded]);

  if (!isLoaded) return null;

  return (
    <ThemeContainer>
      <CustomBrowserRouter>
        <PlatformContainer>
          <RootProvider>
            <Loading />
            <Toast />
            <Route exact path="/login/:roomCode?">
              <Login />
            </Route>
            <Route exact path="/register">
              <Register />
            </Route>
            <Route exact path="/forget-password/:link?">
              <ForgetPassword />
            </Route>
            <Route exact path="/activation-code">
              <ActivationCode />
            </Route>
            <Route exact path="/settings">
              <DeviceTest />
            </Route>
            <Route exact path="/edit-profile">
              <EditProfile />
            </Route>
            <Route exact path={["/", "/room/:roomCode"]}>
              <Home />
            </Route>
            <Route exact path="/classroom/one-to-one">
              <RoomPage>
                <OneToOne />
              </RoomPage>
            </Route>
            <Route exact path="/classroom/small-class">
              <RoomPage>
                <SmallClass />
              </RoomPage>
            </Route>
            <Route exact path="/classroom/meet-class">
              <RoomPage>
                <MeetClass />
              </RoomPage>
            </Route>
            {/* <Route exact path="/classroom/small-class">
              <RoomPage>
                <SmallClass />
              </RoomPage>
            </Route> */}
            <Route exact path="/classroom/big-class">
              <RoomPage>
                <BigClass />
              </RoomPage>
            </Route>
            <Route exact path="/replay/:uuid/:startTime/:endTime/:mediaUrl">
              <ReplayContainer />
            </Route>
            {/* <Route path="/error">
            <ErrorPage />
          </Route> */}
            <Route exact path="/404">
              <PageNotFound />
            </Route>
          </RootProvider>
        </PlatformContainer>
      </CustomBrowserRouter>
    </ThemeContainer>
  );
}
